import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cloneDeep } from 'lodash';
import { AUTOMOBILE_COVER, BI_COW_COVER, BOP_HIRED_NON_OWNED_AUTO_COVER, BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER, BOP_PROPERTY, BOP_TERRORISM_COVER, BUSINESS_HR_COVER, BUSINESS_INTERUPTION, BUSINESS_OWNERS_POLICY_CLAIM_COVER, BUSINESS_OWNERS_POLICY_COVER, CEAL_PERCENTAGE, CL_EXCESS_COVER, CL_MEDIA_LIABILITY_COVER, CL_TERRORISM_COVER, CMR_COVER, COMMERCIAL_BOND_COVER, COMPUTER_BREAKDOWN_COVER, CORPORATE_LEGAL_LIABILITY_COVER, CRIME_COVER, CRIME_EXCESS_COVER, CYBER_CRIME_COVER, CYBER_LIABILITY_COVER, CYBER_SECURITY_COVER, DEBRIS_REMOVAL_COVER, DEDUCTIBLE_COVER, DIRECTORS_OFFICERS_COVER, DRIVERS_NEGLIGENCE, EARNED_FREIGHT_COVER, EMPLOYERS_LIABILITY, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, EXCESS_LEVEL, EXCESS_LIABILITY_COVER, FIDELITY_CRIME, FIRE_DEPARTMENT_COVER, GOODS_IN_TRANSIT, HIRED_IN_PLANT_COVER, HIRE_AND_REWARD, IR35_INSURANCE_COVER, LEGAL_EXPENSES_COVER, LOSS_DATA_COVER, MONEY_ASSAULT_COVER, NON_OWNED_TRAILER, OCCUPATIONAL_PERSONAL_ACCIDENT_COVER, OWNERS_GOODS_EXTENSION, PACKAGE_COVER, PI_CONTINGENT_BODILY_INJURY_COVER, PI_WAIVER_OF_SUBROGATION_COVER, PL_HIRED_NON_OWNED_AUTO_COVER, PL_PRIMARY_NON_CONTRIBUTORY_COVER, PL_PROPERTY_AND_EQUIPMENT_COVER, PL_TERRORISM_COVER, PL_WAIVER_OF_SUBROGATION_COVER, POLICY_EXTEND_COVER_CLAIMS_USA_CANADA, POLLUTANT_CLEAN_UP, PORTABLE_EQUIPMENT, PORTABLE_EQUIPMENT_COVER, PRE_POWER_UNIT_COVER, PROFESSIONAL_INDEMNITY, PROFESSIONAL_INDEMNITY_CLAIM_COVER, PROPERTY_COVER, PROPERTY_COVER_TYPE_LIST, PROPERTY_DAMAGE, PROPERTY_EXCESS_COVER, PUBLIC_LIABILITY, PUBLIC_LIABILITY_CLAIM_COVER, REFRIGERATION_BREAKDOWN, RELOADING_COVER, REUSABLE_PACKING_CONTAINERS, REWARD_COVERAGE_COVER, TARPS_CHAINS, THIRD_PARTY_BODILY_INJURY, WORKERS_COMPENSATION_COVER } from '../constants/coverage';
import { AmericanCountryList, PROVIDER_SOURCE } from '../constants/quote';
import { getLocalTranslation } from '../utils/i18nKit';
import { getCmrCoverDisplayText, getEmployersLiabilityDisplayText, getExcessLevelDisplayText, getGoodsInTransitDisplayText, getHireAndRewardDisplayText, getProfessionalIndemnityDisplayText, getPublicLiabilityDisplayText } from '../utils/quote/coverage';
export var getCoverageConstantText = function getCoverageConstantText(key) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return $t("kit:".concat(key));
};
export var getCoverInfoMap = function getCoverInfoMap(config) {
  var _ref;

  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return _ref = {}, _defineProperty(_ref, PROFESSIONAL_INDEMNITY, {
    value: PROFESSIONAL_INDEMNITY,
    label: getProfessionalIndemnityDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:professional_indemnity')
    })),
    desc: $t('kit:coverages.pi_brief_introduction'),
    order: 1
  }), _defineProperty(_ref, PUBLIC_LIABILITY, {
    value: PUBLIC_LIABILITY,
    label: getPublicLiabilityDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:public_liability')
    })),
    desc: $t('kit:coverages.pl_brief_introduction'),
    order: 2
  }), _defineProperty(_ref, EMPLOYERS_LIABILITY, {
    value: EMPLOYERS_LIABILITY,
    label: getEmployersLiabilityDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:employers_liability')
    })),
    desc: $t('kit:coverages.el_brief_introduction'),
    order: 3
  }), _defineProperty(_ref, EXCESS_LEVEL, {
    value: EXCESS_LEVEL,
    label: getExcessLevelDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:coverLabels.professional_indemnity_excess_level')
    })),
    desc: $t('kit:excess_payment_deductible_professional_indemnity_claim'),
    order: 4
  }), _defineProperty(_ref, GOODS_IN_TRANSIT, {
    value: GOODS_IN_TRANSIT,
    label: getGoodsInTransitDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:goods_in_transit')
    })),
    desc: $t('kit:covers_items_theft_loss_damage_transportation'),
    order: 5
  }), _defineProperty(_ref, CMR_COVER, {
    value: CMR_COVER,
    label: getCmrCoverDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:cmr_cover')
    })),
    desc: $t('kit:protects_company_international_road_journey_losses'),
    order: 6
  }), _defineProperty(_ref, HIRE_AND_REWARD, {
    value: HIRE_AND_REWARD,
    label: getHireAndRewardDisplayText(_objectSpread(_objectSpread({}, config), {}, {
      initialText: $t('kit:hire_and_reward')
    })),
    desc: '',
    order: 7
  }), _defineProperty(_ref, DIRECTORS_OFFICERS_COVER, {
    value: DIRECTORS_OFFICERS_COVER,
    label: $t('kit:coverLabels.directors_officers'),
    desc: $t('kit:coverages.directors_officers_brief_introduction_1')
  }), _defineProperty(_ref, CORPORATE_LEGAL_LIABILITY_COVER, {
    value: CORPORATE_LEGAL_LIABILITY_COVER,
    label: $t('kit:coverLabels.corporate_legal_liability')
  }), _defineProperty(_ref, EMPLOYMENT_PRACTICES_COVER, {
    value: EMPLOYMENT_PRACTICES_COVER,
    label: $t('kit:coverLabels.employment_practices_liability'),
    desc: $t('kit:coverages.employment_practices_brief_introduction_1')
  }), _defineProperty(_ref, CYBER_LIABILITY_COVER, {
    value: CYBER_LIABILITY_COVER,
    label: $t('kit:coverLabels.cyber_liability'),
    desc: 'Cyber Insurance, also known as Cyber Liability Insurance, is a specialized policy designed to protect businesses from the financial fallout of cyberattacks and data breaches. It covers costs related to data recovery, legal fees, regulatory fines, and customer notification, while also providing critical support for crisis management and system restoration.'
  }), _defineProperty(_ref, CYBER_CRIME_COVER, {
    value: CYBER_CRIME_COVER,
    label: $t('kit:coverLabels.cyber_crime')
  }), _defineProperty(_ref, PROPERTY_COVER, {
    value: PROPERTY_COVER,
    label: $t('kit:coverLabels.do_require_property_cover'),
    desc: $t('kit:coverDescriptions.property_cover_desc'),
    abbrTitle: 'Property Cover'
  }), _defineProperty(_ref, BUSINESS_HR_COVER, {
    value: BUSINESS_HR_COVER,
    label: $t('kit:coverLabels.do_require_business_hr_cover')
  }), _defineProperty(_ref, AUTOMOBILE_COVER, {
    value: AUTOMOBILE_COVER,
    label: $t('kit:automobile')
  }), _defineProperty(_ref, CYBER_SECURITY_COVER, {
    value: CYBER_SECURITY_COVER,
    label: $t('kit:cyber_security')
  }), _defineProperty(_ref, EXCESS_LIABILITY_COVER, {
    value: EXCESS_LIABILITY_COVER,
    label: $t('kit:excess_umbrella_liability')
  }), _defineProperty(_ref, COMMERCIAL_BOND_COVER, {
    value: COMMERCIAL_BOND_COVER,
    label: $t('kit:fidelity_crime_commercial_bond')
  }), _defineProperty(_ref, HIRED_IN_PLANT_COVER, {
    value: HIRED_IN_PLANT_COVER,
    label: $t('kit:hired_in_plant')
  }), _defineProperty(_ref, IR35_INSURANCE_COVER, {
    value: IR35_INSURANCE_COVER,
    label: $t('kit:ir35_insurance')
  }), _defineProperty(_ref, OCCUPATIONAL_PERSONAL_ACCIDENT_COVER, {
    value: OCCUPATIONAL_PERSONAL_ACCIDENT_COVER,
    label: $t('kit:occupational_personal_accident')
  }), _defineProperty(_ref, PORTABLE_EQUIPMENT_COVER, {
    value: PORTABLE_EQUIPMENT_COVER,
    label: $t('kit:coverLabels.do_require_portable_equipment_cover'),
    // desc: $t('kit:coverDescriptions.portable_equipment_desc'),
    desc: [{
      text: 'Covered Worldwide',
      isBold: true
    }, {
      text: 'Covers your business’s portable items such as laptops, tools and cameras against theft, loss or accidental damage while away from your premises, including worldwide use.'
    }, {
      text: 'This helps you repair or replace essential equipment quickly and minimise disruption to your business.'
    }]
  }), _defineProperty(_ref, WORKERS_COMPENSATION_COVER, {
    value: WORKERS_COMPENSATION_COVER,
    label: $t('kit:workers_compensation')
  }), _defineProperty(_ref, POLICY_EXTEND_COVER_CLAIMS_USA_CANADA, {
    value: POLICY_EXTEND_COVER_CLAIMS_USA_CANADA,
    label: '',
    desc: $t('kit:coverDescriptions.policy_extend_usa_canada_desc')
  }), _defineProperty(_ref, FIDELITY_CRIME, {
    value: FIDELITY_CRIME,
    label: $t('kit:coverLabels.fidelity_crime'),
    desc: $t('kit:coverages.fidelity_crimepl_brief_introduction_1')
  }), _defineProperty(_ref, DRIVERS_NEGLIGENCE, {
    value: DRIVERS_NEGLIGENCE,
    label: $t('kit:coverLabels.drivers_negligence'),
    desc: $t('kit:coverDescriptions.drivers_negligence_desc')
  }), _defineProperty(_ref, BUSINESS_INTERUPTION, {
    value: BUSINESS_INTERUPTION,
    // label: $t('kit:coverLabels.do_require_business_interruption_cover'),
    label: 'Do you require Business Interruption cover?',
    // desc: $t('kit:coverDescriptions.business_interruption_desc'),
    desc: 'Helps cover additional costs to keep your business operating following insured damage to your premises or equipment. This cover is limited to additional expenses and does not include loss of income or profit.',
    abbrTitle: 'Business interruption'
  }), _defineProperty(_ref, PROPERTY_COVER_TYPE_LIST, {
    value: PROPERTY_COVER_TYPE_LIST,
    label: $t('kit:coverLabels.what_type_property_cover'),
    desc: $t('kit:coverLabels.what_type_property_cover')
  }), _defineProperty(_ref, COMPUTER_BREAKDOWN_COVER, {
    value: COMPUTER_BREAKDOWN_COVER,
    label: $t('kit:coverLabels.computer_breakdown'),
    desc: ''
  }), _defineProperty(_ref, MONEY_ASSAULT_COVER, {
    value: MONEY_ASSAULT_COVER,
    label: $t('kit:coverLabels.money_assault'),
    desc: ''
  }), _defineProperty(_ref, LEGAL_EXPENSES_COVER, {
    value: LEGAL_EXPENSES_COVER,
    label: 'Legal Expenses',
    desc: 'Covers the legal costs of pursuing or defending disputes arising from your everyday business activities, such as contract, employment or tax disputes.'
  }), _defineProperty(_ref, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, {
    value: EMPLOYMENT_PRACTICES_EXCESS_LEVEL,
    label: $t('kit:coverLabels.employment_practices_excess_level')
  }), _defineProperty(_ref, PACKAGE_COVER, {
    value: PACKAGE_COVER,
    label: $t('kit:coverLabels.package')
  }), _defineProperty(_ref, PRE_POWER_UNIT_COVER, {
    value: PRE_POWER_UNIT_COVER,
    label: $t('kit:greateAmericanCover.motor_truck_cargo')
  }), _defineProperty(_ref, DEDUCTIBLE_COVER, {
    value: DEDUCTIBLE_COVER,
    label: $t('kit:greateAmericanCover.deductible')
  }), _defineProperty(_ref, RELOADING_COVER, {
    value: RELOADING_COVER,
    label: $t('kit:greateAmericanCover.reloading')
  }), _defineProperty(_ref, DEBRIS_REMOVAL_COVER, {
    value: DEBRIS_REMOVAL_COVER,
    label: $t('kit:greateAmericanCover.debris_removal')
  }), _defineProperty(_ref, EARNED_FREIGHT_COVER, {
    value: EARNED_FREIGHT_COVER,
    label: $t('kit:greateAmericanCover.earned_freight')
  }), _defineProperty(_ref, FIRE_DEPARTMENT_COVER, {
    value: FIRE_DEPARTMENT_COVER,
    label: $t('kit:greateAmericanCover.fire_department')
  }), _defineProperty(_ref, LOSS_DATA_COVER, {
    value: LOSS_DATA_COVER,
    label: $t('kit:greateAmericanCover.loss_data')
  }), _defineProperty(_ref, REWARD_COVERAGE_COVER, {
    value: REWARD_COVERAGE_COVER,
    label: $t('kit:greateAmericanCover.reward_coverage')
  }), _defineProperty(_ref, POLLUTANT_CLEAN_UP, {
    value: POLLUTANT_CLEAN_UP,
    label: $t('kit:greateAmericanCover.pollutant_clean_up')
  }), _defineProperty(_ref, REFRIGERATION_BREAKDOWN, {
    value: REFRIGERATION_BREAKDOWN,
    label: $t('kit:greateAmericanCover.refrigeration_breakdown')
  }), _defineProperty(_ref, OWNERS_GOODS_EXTENSION, {
    value: OWNERS_GOODS_EXTENSION,
    label: $t('kit:greateAmericanCover.owners_goods_extension')
  }), _defineProperty(_ref, NON_OWNED_TRAILER, {
    value: NON_OWNED_TRAILER,
    label: $t('kit:greateAmericanCover.container_coverage')
  }), _defineProperty(_ref, REUSABLE_PACKING_CONTAINERS, {
    value: REUSABLE_PACKING_CONTAINERS,
    label: $t('kit:greateAmericanCover.reusable_packing_containers')
  }), _defineProperty(_ref, TARPS_CHAINS, {
    value: TARPS_CHAINS,
    label: $t('kit:greateAmericanCover.moving_equipment')
  }), _defineProperty(_ref, CEAL_PERCENTAGE, {
    value: CEAL_PERCENTAGE,
    label: $t('kit:coverLabels.claims_expenses_additional_limit')
  }), _defineProperty(_ref, THIRD_PARTY_BODILY_INJURY, {
    value: THIRD_PARTY_BODILY_INJURY,
    label: $t('kit:coverLabels.third_party_bodily_injury')
  }), _defineProperty(_ref, PROPERTY_DAMAGE, {
    value: PROPERTY_DAMAGE,
    label: $t('kit:coverLabels.property_damage')
  }), _defineProperty(_ref, BI_COW_COVER, {
    value: BI_COW_COVER,
    label: $t('kit:coverLabels.business_interruption')
  }), _defineProperty(_ref, PORTABLE_EQUIPMENT, {
    value: PORTABLE_EQUIPMENT,
    label: $t('kit:coverLabels.portable_equipment')
  }), _defineProperty(_ref, BUSINESS_OWNERS_POLICY_COVER, {
    value: BUSINESS_OWNERS_POLICY_COVER,
    label: 'Business owners policy',
    desc: 'A Business Owners Policy (BOP) is a bundled insurance solution designed for small to medium-sized businesses, combining General Liability and Commercial Property Insurance into a single, cost-effective package. It streamlines risk management by covering essential needs like legal defense, third-party injury claims, and damage to physical assets, often including Business Interruption coverage to replace lost income during closures caused by covered events.'
  }), _defineProperty(_ref, BOP_HIRED_NON_OWNED_AUTO_COVER, {
    value: BOP_HIRED_NON_OWNED_AUTO_COVER,
    label: 'Hired Auto and Non-Owned Auto (Each Claim Limit)'
  }), _defineProperty(_ref, BOP_TERRORISM_COVER, {
    value: BOP_TERRORISM_COVER,
    label: 'Terrorism coverage'
  }), _defineProperty(_ref, CRIME_EXCESS_COVER, {
    value: CRIME_EXCESS_COVER,
    label: 'Crime Excess Cover'
  }), _defineProperty(_ref, PROFESSIONAL_INDEMNITY_CLAIM_COVER, {
    value: PROFESSIONAL_INDEMNITY_CLAIM_COVER,
    label: 'Each claim limit'
  }), _defineProperty(_ref, PI_CONTINGENT_BODILY_INJURY_COVER, {
    value: PI_CONTINGENT_BODILY_INJURY_COVER,
    label: 'Contingent Bodily Injury and Property Damage'
  }), _defineProperty(_ref, PI_WAIVER_OF_SUBROGATION_COVER, {
    value: PI_WAIVER_OF_SUBROGATION_COVER,
    label: 'Waiver of Subrogation'
  }), _defineProperty(_ref, PUBLIC_LIABILITY_CLAIM_COVER, {
    value: PUBLIC_LIABILITY_CLAIM_COVER,
    label: 'Each claim limit'
  }), _defineProperty(_ref, PL_PROPERTY_AND_EQUIPMENT_COVER, {
    value: PL_PROPERTY_AND_EQUIPMENT_COVER,
    label: 'Business Property and Equipment'
  }), _defineProperty(_ref, PL_HIRED_NON_OWNED_AUTO_COVER, {
    value: PL_HIRED_NON_OWNED_AUTO_COVER,
    label: 'Hired and Non-Owned Auto'
  }), _defineProperty(_ref, PL_TERRORISM_COVER, {
    value: PL_TERRORISM_COVER,
    label: 'Terrorism Coverage'
  }), _defineProperty(_ref, PL_WAIVER_OF_SUBROGATION_COVER, {
    value: PL_WAIVER_OF_SUBROGATION_COVER,
    label: 'Waiver of Subrogation'
  }), _defineProperty(_ref, PL_PRIMARY_NON_CONTRIBUTORY_COVER, {
    value: PL_PRIMARY_NON_CONTRIBUTORY_COVER,
    label: 'Primary and Non-Contributory'
  }), _defineProperty(_ref, BUSINESS_OWNERS_POLICY_CLAIM_COVER, {
    value: BUSINESS_OWNERS_POLICY_CLAIM_COVER,
    label: 'Each Claim Limit'
  }), _defineProperty(_ref, PROPERTY_EXCESS_COVER, {
    value: PROPERTY_EXCESS_COVER,
    label: 'Business Property Deductible'
  }), _defineProperty(_ref, BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER, {
    value: BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER,
    label: 'Hired Auto and Non-Owned Auto (Deductible)'
  }), _defineProperty(_ref, CRIME_COVER, {
    value: CRIME_COVER,
    label: 'Crime Package (Each Claim Limit)'
  }), _defineProperty(_ref, CL_EXCESS_COVER, {
    value: CL_EXCESS_COVER,
    label: 'Deductible'
  }), _defineProperty(_ref, CL_TERRORISM_COVER, {
    value: CL_TERRORISM_COVER,
    label: 'Terrorism coverage'
  }), _defineProperty(_ref, CL_MEDIA_LIABILITY_COVER, {
    value: CL_MEDIA_LIABILITY_COVER,
    label: 'Media Liability'
  }), _ref;
};
export var getCoverInfoMapWithExtraConfig = function getCoverInfoMapWithExtraConfig(config) {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  var basicMap = cloneDeep(getCoverInfoMap());

  if (AmericanCountryList.includes(config === null || config === void 0 ? void 0 : config.countryCode) || [PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value, PROVIDER_SOURCE().HISCOX_US.value].includes(config === null || config === void 0 ? void 0 : config.provideCode)) {
    var _objectSpread2;

    basicMap = _objectSpread(_objectSpread({}, basicMap), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, PROFESSIONAL_INDEMNITY, _objectSpread(_objectSpread({}, basicMap[PROFESSIONAL_INDEMNITY]), {}, {
      label: [PROVIDER_SOURCE().HISCOX_US.value].includes(config === null || config === void 0 ? void 0 : config.provideCode) ? 'Professional Liability' : $t('kit:coverLabels.professional_liability_eo'),
      desc: 'Professional Liability Insurance, often called Errors and Omissions (E&O) Insurance, is essential for professionals who provide expert services or advice. It safeguards against claims of negligence, mistakes, or failure to perform, covering legal defense costs and settlements.'
    })), _defineProperty(_objectSpread2, PUBLIC_LIABILITY, _objectSpread(_objectSpread({}, basicMap[PUBLIC_LIABILITY]), {}, {
      label: $t('kit:coverLabels.general_liability'),
      desc: [{
        text: "General Liability Insurance, often structured as a Commercial General Liability (CGL) policy, is a foundational coverage for businesses. It protects against financial loss from claims of bodily injury, property damage, and personal/advertising injury caused by the business's operations, products, or services, covering legal defense and settlements."
      }]
    })), _defineProperty(_objectSpread2, EXCESS_LEVEL, _objectSpread(_objectSpread({}, basicMap[EXCESS_LEVEL]), {}, {
      label: $t('kit:coverLabels.pl_deductible_excess'),
      desc: [{
        text: $t('kit:coverDescriptions.pl_deductible_desc')
      }]
    })), _defineProperty(_objectSpread2, CEAL_PERCENTAGE, _objectSpread(_objectSpread({}, basicMap[CEAL_PERCENTAGE]), {}, {
      desc: [{
        text: $t('kit:coverDescriptions.ceal_desc')
      }]
    })), _objectSpread2));
  }

  if ([PROVIDER_SOURCE().HISCOX_US.value].includes(config === null || config === void 0 ? void 0 : config.provideCode)) {
    var _objectSpread3;

    basicMap = _objectSpread(_objectSpread({}, basicMap), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, EXCESS_LEVEL, _objectSpread(_objectSpread({}, basicMap[EXCESS_LEVEL]), {}, {
      label: 'Deductible'
    })), _defineProperty(_objectSpread3, BOP_PROPERTY, _objectSpread(_objectSpread({}, basicMap[BOP_PROPERTY]), {}, {
      label: 'Business Personal Property Limit'
    })), _defineProperty(_objectSpread3, CRIME_EXCESS_COVER, _objectSpread(_objectSpread({}, basicMap[CRIME_EXCESS_COVER]), {}, {
      label: 'Crime Package (Deductible)'
    })), _objectSpread3));
  } else {
    basicMap[PROPERTY_COVER_TYPE_LIST] = _objectSpread(_objectSpread({}, basicMap[PROPERTY_COVER_TYPE_LIST]), {}, {
      label: $t('kit:coverLabels.property')
    });
  }

  basicMap[PORTABLE_EQUIPMENT_COVER] = _objectSpread(_objectSpread({}, basicMap[PORTABLE_EQUIPMENT_COVER]), {}, {
    label: $t('kit:coverLabels.portable_equipment_short')
  });
  basicMap[BUSINESS_INTERUPTION] = _objectSpread(_objectSpread({}, basicMap[BUSINESS_INTERUPTION]), {}, {
    label: $t('kit:coverLabels.business_interruption')
  });
  return basicMap;
};